import { gql } from '@apollo/client'

export const BRAND_LANDSCAPE = gql`
  query BrandLandscapeQuery($input: DateRangeInput!) {
    brandLandscape(input: $input) {
      results {
        brand {
          name
          id
        }
        sovi
        changeInSovi
      }
    }
  }
`
